<div class="w-full reschedule-job-dialog cursor-default">
    <div class="flex justify-between border-b border-b-gray-300 zuper-dialog-header">
        <div class="flex items-center w-4/5">
            <h6 mat-dialog-title class="font-semibold primary-font overflow-hidden break-words">{{dialogTitle}}</h6>
        </div>
        <div class="flex items-center mr-1">
            <span mat-dialog-close
                class="rounded-full cursor-pointer flex justify-center items-center hover:bg-gray-200 h-10 w-10 p-2 ml-2">
                <em class="ti ti-x text-xl font-bold"></em>
            </span>
        </div>
    </div>
    <div class="flex flex-col zuper-dialog-body max-dialog-height overflow-y-auto zuper-scrollbar">
        <div>
            <form [formGroup]="rescheduleRouteForm" class="cancelForm h-full overflow-y-none" autocomplete="off">
                <div class="grid grid-cols-2 gap-x-4">
                    <div class="flex flex-col w-full mb-4">
                        <div>
                            <label
                                class="block text-base font-medium mb-2 text-gray-700 required cursor-pointer">{{'dispatchBoard.scheduler.reschedule.route_start_time'
                                | translate}}</label>
                        </div>
                        <div class="grid grid-cols-2 gap-x-4 ">
                            <mat-form-field appearance="fill" class="w-full h-fit" [floatLabel]="'always'">
                                <input matInput readonly class="cursor-pointer" (focus)="startDatePicker?.open()"
                                    [matDatepicker]="startDatePicker" formControlName="startDate"
                                    [datePickerFormat]="dateFormat" (dateChange)="onDateChange()"
                                    placeholder="{{'text.choose_date' | translate}}">
                                <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                                <mat-datepicker #startDatePicker></mat-datepicker>
                            </mat-form-field>
                            <mat-form-field appearance="fill" class="w-full h-fit" [floatLabel]="'always'">
                                <input matInput readonly class="cursor-pointer"
                                    placeholder="{{'text.pick_time' | translate}}"
                                    formControlName="startTime" [matMenuTriggerFor]="startTimePicker" />
                                <button mat-icon-button matSuffix [matMenuTriggerFor]="startTimePicker">
                                    <mat-icon [svgIcon]="'heroicons_solid:clock'"></mat-icon>
                                </button>
                                <mat-menu #startTimePicker="matMenu">
                                    <div class="flex flex-col">
                                        <div class="flex justify-center">
                                            <ngx-mat-timepicker (click)="$event.stopPropagation()" [disabled]="false"
                                                [showSpinners]="true" [stepHour]="1" [stepMinute]="1"
                                                [showSeconds]="false" [enableMeridian]="isMeridian()"
                                                formControlName="startTimePicker">
                                            </ngx-mat-timepicker>
                                        </div>
                                        <div class="flex justify-center">
                                            <button mat-stroked-button>
                                                {{'text.ok' | translate}}
                                            </button>
                                        </div>
                                    </div>
                                </mat-menu>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="flex flex-col gap-x-4 w-full mb-4">
                        <div>
                            <label
                                class="block text-base font-medium mb-2 text-gray-700 required">{{'dispatchBoard.scheduler.reschedule.route_end_time'
                                | translate}}</label>
                        </div>
                        <div class="grid grid-cols-2 gap-x-4">
                            <mat-form-field appearance="fill" class="w-full h-fit" [floatLabel]="'always'">
                                <input matInput readonly [min]="rescheduleRouteForm?.controls?.startDate?.value"
                                    class="cursor-pointer" [matDatepicker]="endDatePicker"
                                    (focus)="endDatePicker?.open()" formControlName="endDate"
                                    [datePickerFormat]="dateFormat" (dateChange)="onDateChange()"
                                    placeholder="{{'text.choose_date' | translate}}">
                                <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                                <mat-datepicker #endDatePicker></mat-datepicker>
                            </mat-form-field>
                            <mat-form-field appearance="fill" class="w-full h-fit" [floatLabel]="'always'">
                                <input matInput readonly
                                    placeholder="{{'text.pick_time' | translate}}"
                                    class="cursor-pointer" [matMenuTriggerFor]="toMenu" formControlName="endTime" />
                                <mat-error
                                    *ngIf="rescheduleRouteForm.controls.endTime.hasError('invalidEndTime')">{{'dispatchBoard.scheduler.reschedule.start_end_time_invalid'
                                    | translate}}</mat-error>
                                    <mat-error
                                    *ngIf="rescheduleRouteForm.controls.endTime.hasError('routeMaxDurationError')">{{'dispatchBoard.error.route_max_duration'
                                    | translate}}</mat-error>
                                <button mat-icon-button matSuffix [matMenuTriggerFor]="toMenu">
                                    <mat-icon [svgIcon]="'heroicons_solid:clock'"></mat-icon>
                                </button>
                                <mat-menu #toMenu="matMenu">
                                    <div class="flex flex-col">
                                        <div class="flex justify-center">
                                            <ngx-mat-timepicker formControlName="endTimePicker"
                                                (click)="$event.stopPropagation()" [disabled]="false"
                                                [showSpinners]="true" [stepHour]="1" [stepMinute]="1"
                                                [showSeconds]="false" [enableMeridian]="isMeridian()">
                                            </ngx-mat-timepicker>
                                        </div>
                                        <div class="flex justify-center">
                                            <button mat-stroked-button>
                                                {{'text.ok' | translate}}
                                            </button>
                                        </div>
                                    </div>
                                </mat-menu>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="mb-2 text-base cursor-default" *ngIf="!blockJobsOnHoliday">
                    <div *ngIf="!warningsList?.routeDurationExceedWarning?.show">
                        <mat-error
                            *ngIf="warningsList?.dateWarnings?.show">{{warningsList?.dateWarnings?.msg}}</mat-error>
                        <mat-error
                            *ngIf="warningsList?.shiftHoursExceedWarning?.show">{{warningsList?.shiftHoursExceedWarning?.msg}}</mat-error>
                        <mat-error
                            *ngIf="!warningsList?.dateWarnings?.show && !warningsList?.shiftHoursExceedWarning?.show && warningsList?.timeWarnings?.show">{{warningsList?.timeWarnings?.msg}}</mat-error>    
                        <mat-error *ngIf="warningsList?.eventOverlapWarning?.show">{{warningsList?.eventOverlapWarning?.msg}}</mat-error>
                    </div>
                </div>
                <div class="flex items-center space-x-3 py-1" *ngIf="blockJobsOnHoliday">
                    <i class="ti ti-alert-triangle text-red-500 text-3xl cursor-default"></i>
                    <span
                        class="text-red-500 font-medium text-base cursor-default">{{'dispatchBoard.scheduler.error.block_route_on_holiday'
                        | translate}} : {{blockHolidayName}}</span>
                </div>
            </form>
        </div>
    </div>

    <div class="flex justify-end border-t border-gray-300 zuper-dialog-footer">
        <div class="flex justify-around space-x-4 bg-gray-50">
            <button type="button" mat-stroked-button mat-dialog-close
                class="px-6 btn-small items-center py-2 border b-1 border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-600 bg-white hover:bg-gray-50 focus:outline-none">
                {{'cancel.text' | translate}}</button>
            <button [disabled]="disableUpdateBtn || rescheduleRouteForm.invalid || validatingOverlapsAndTimeoff"
                class="flex min-w-24 btn-small px-6 items-center py-2 border text-base b-1 shadow-sm text-white font-medium rounded-md text-white-600 focus:outline-none bg-primary"
                [ngClass]="{'opacity-30 cursor-not-allowed submitBtn default-hover': disableUpdateBtn || rescheduleRouteForm.invalid}"
                (click)="rescheduleRoute()">
                <mat-spinner [diameter]="30" class="mr-2" *ngIf="validatingOverlapsAndTimeoff"></mat-spinner>
                <span class="text-white">{{'update' | translate}}</span>
            </button>
        </div>
    </div>
</div>